import { OptionalLink, OptionalLinkProps } from '../01-core/OptionalLink';

export interface BreadcrumbItemProps extends OptionalLinkProps {
  /** The label */
  label: string;
  /** The link */
  href: string;
  /** The optional title */
  title?: string;
}

export interface BreadcrumbProps {
  /** The primary breadcrumb item */
  primary: BreadcrumbItemProps;
  /** The breadcrumb items */
  items: BreadcrumbItemProps[];
  /** Additional class */
  className?: string;
}

/** A block rendering the breadcrumb navigation */
export const Breadcrumb = ({
  primary,
  items,
  className,
  ...props
}: BreadcrumbProps) => {
  return (
    <nav className={['breadcrumb', className].join(' ')} {...props}>
      <ul className="breadcrumb__nav">
        {items.map((item, i) => {
          return (
            <li key={i} className="breadcrumb__nav-item">
              <OptionalLink
                className="breadcrumb__nav-link"
                href={item.href}
                title={item.title}
              >
                {item.label}
              </OptionalLink>
            </li>
          );
        })}
      </ul>
      <OptionalLink
        className="breadcrumb__primary"
        href={primary.href}
        title={primary.title}
      >
        {primary.label}
      </OptionalLink>
    </nav>
  );
};
